import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Staff } from '@app/models/staff.model';
import { StaffService } from '@app/services/staff.service';
import { Store } from '@ngxs/store';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'app-staff-search',
  templateUrl: './staff-search.component.html',
  styleUrls: ['./staff-search.component.scss'],
})
export class StaffSearchComponent {
  @Output() staffChange = new EventEmitter<Staff>();

  form: FormControl;
  filtered$: Observable<Staff[] | null>;
  get staffList() {
    return this.staffService.staffList;
  }

  constructor(
    protected staffService: StaffService,
    protected store: Store,
    protected cd: ChangeDetectorRef
  ) {
    this.form = new FormControl('');
    this.filtered$ = this.form.valueChanges.pipe(
      startWith(''),
      map(
        (value) =>
          this.staffList?.filter((staff) => staff.name.includes(value)) ?? null
      )
    );
  }

  onChange(staff: Staff): void {
    this.staffChange.emit(staff);
  }
}
